import { ArticleType } from '@nemuru-eng/js-api-client';
import { z } from 'zod';

import { MinimalFormItemSchema } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/schemas/MinimalFormItemSchema';
import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import { requiredFutureDate } from '@/utils/zodUtils';

export const ServiceFormItemSchema = (t: GetTextIdTranslationType) =>
  MinimalFormItemSchema(t).merge(
    z
      .object({
        type: z.literal(ArticleType.SERVICE),
        endDate: requiredFutureDate(t),
      })
      .strict(),
  );
